import { SortAndPagination } from 'components/SortAndPagination';
import { useIntl } from 'react-intl';
import { TransactionTypesSearchParamsType, useSuspenseTransactionTypes } from '../api/getTransactionTypes';
import { getCleosStatus } from 'utils/statusUtils';
import { Table } from 'components/Table';
import { SortConfig } from 'components/Table/types';
import { FetchingIndicator } from 'components/FetchingIndicator';
import { useSearchNavigationSource } from 'hooks/context/useSearchNavigation';

interface TransactionTypesSearchResultProps {
  searchParams: TransactionTypesSearchParamsType;
  sortConfig: SortConfig;
  handlePaging: (page: number, size: number) => void;
}

export const TransactionTypesSearchResult = ({
  searchParams,
  sortConfig,
  handlePaging,
}: TransactionTypesSearchResultProps) => {
  const intl = useIntl();
  const registerSearchNavigation = useSearchNavigationSource('/transaction-types');
  const {
    data: { data: transactionTypes },
    isFetching,
    dataUpdatedAt,
  } = useSuspenseTransactionTypes({ searchParams });

  const { totalElements, page, size, items } = transactionTypes;
  const parseCleosStatus = (status: unknown) => `${getCleosStatus(status, intl)}`;

  const columns = {
    id: {
      text: intl.formatMessage({ id: 'generalValues.id' }),
      link: { url: '%1$s' },
      sortable: true,
      noWrap: true,
      default: true,
    },
    name: { text: intl.formatMessage({ id: 'generalValues.name' }), sortable: true, truncate: true, default: true },
    type: { text: intl.formatMessage({ id: 'columns.type' }), sortable: true, default: true },
    status: {
      text: intl.formatMessage({ id: 'generalValues.status' }),
      sortable: true,
      default: true,
      parse: parseCleosStatus,
    },
  };

  return (
    <FetchingIndicator isFetching={isFetching}>
      <SortAndPagination
        totalElements={totalElements}
        page={page}
        size={size}
        items={items}
        handlePaging={handlePaging}
        handleSorting={sortConfig.handleSorting}
        sorting={searchParams.sort}
        dataUpdatedAt={dataUpdatedAt}
      >
        <Table
          onFilteredRowsChange={registerSearchNavigation}
          rows={items}
          columns={columns}
          sortConfig={sortConfig}
          tableKey="transactionTypes"
          noResultMessage={intl.formatMessage({ id: 'generalValues.noResultBasedOnInput' })}
        />
      </SortAndPagination>
    </FetchingIndicator>
  );
};
